import * as Sentry from '@sentry/browser';
import { SENTRY_DSN } from './constants';

const initSentry = () => {
  if (SENTRY_DSN && process.env.NODE_ENV !== 'development') {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: process.env.NODE_ENV,
      maxBreadcrumbs: 10,
    });
  }
};

export default initSentry;
